import { Controller } from "@hotwired/stimulus"
import type { TurboSubmitEndEvent } from "@hotwired/turbo"

export default class ContactFormController extends Controller {
  handleSubmit(event: TurboSubmitEndEvent) {
    if (event.detail.success) {
      const modalEl = this.element.closest(".modal")
      if (modalEl) {
        const modal = globalThis.bootstrap.Modal.getInstance(modalEl)
        if (modal) {
          modal.hide()
        }
      }
    }
  }
}
